import { render, staticRenderFns } from "./expansionColumn.vue?vue&type=template&id=7ffc5160"
import script from "./expansionColumn.vue?vue&type=script&lang=js"
export * from "./expansionColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports